import React from "react";
import { Container } from "@mui/material";
import WindowOrderList from "../components/WorkOrders/RFWindows/WindowOrderList";

export default function Windows(props) {
    const { user, token, handleOpenSnackbar, darkState } = props;

    return (
        <Container
            maxWidth={false}
            sx={{
                pt: 0,
                pb: { xs: 2, sm: 3, md: 4 },
                px: 0,
            }}
        >
            <WindowOrderList
                handleOpenSnackbar={handleOpenSnackbar}
                darkState={darkState}
                user={user}
                token={token}
            />
        </Container>
    );
}
